import { DateRangeValue } from '@hub-components';

export const DEFAULT_DATE_INTERVAL: DateRangeValue = {
  dynamic: { title: 'Last Month', name: 'last', num: 1, unit: 'month' },
  type: 'dynamic',
  range: 'Last Month',
};

export const COMPARISON_OPTIONS = [
  { name: 'None', value: 'none' },
  { name: 'Previous Period', value: 'previous_period' },
  { name: 'Previous Year(s)', value: 'previous_year' },
];

export const DEFAULT_COMPARE_TO = { name: 'None', value: 'none' };

export const DEFAULT_WIDGET_HEIGHT = 270;

export const WIDGET_SIZE_OPTIONS = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
];

export const WIDGET_TYPE_OPTIONS = [
  { label: 'KPI', value: 'kpi' },
  { label: 'KPI Line', value: 'kpi-line' },
  { label: 'Spline Bar', value: 'spline-bar' },
  { label: 'Pie', value: 'pie' },
  { label: 'Line', value: 'line' },
  { label: 'Map', value: 'map' },
];

export const MAP_OPTIONS = [
  { value: 'custom/world-robinson', name: 'World' },
  { value: 'custom/asia', name: 'Asia' },
  { value: 'custom/europe', name: 'Europe' },
  { value: 'countries/be/be-all', name: 'Belgium' },
  { value: 'countries/ca/ca-all', name: 'Canada' },
  { value: 'countries/nl/nl-all', name: 'Netherlands' },
  { value: 'countries/us/us-all', name: 'USA' },
];

export const COUNTRY_SPECIFIC_MAPS = ['countries/be/be-all', 'countries/ca/ca-all', 'countries/nl/nl-all', 'countries/us/us-all'];

export const DEFAULT_BREAKDOWN_BORDER_COLOR = 'rgba(0, 0, 0, 0.2)';
export const DEFAULT_BREAKDOWN_TEXT_COLOR = 'rgba(0, 0, 0, 0.6)';

export const EXPORT_INFO = {
  success: [
    {
      severity: 'success',
      title: 'Screenshot ready',
      description: '',
      icon: 'fa fa-download',
    },
  ],
  error: [
    {
      severity: 'error',
      title: 'Screenshot failed',
      description: '',
      icon: 'fa fa-exclamation-triangle',
    },
  ],
  exporting: [
    {
      severity: 'info',
      title: 'Generating screenshot',
      description: 'Your screenshot is being generated and you will be notified when it is ready for download.',
      icon: '',
    },
  ],
};

export const BREAKDOWN_INDENTATION = 12;
